import {IStateAuth} from './reducer';
import {IUserAgent} from '../../common/type';
import {
  createBasicActions,
  createActionFetch,
  createAction,
} from '../../common/util/redux';

export enum ActionType {
  SetValue = 'auth.SetValue',
  SetPropertyValues = 'auth.SetPropertyValues',
  RemoveValues = 'auth.RemoveValues',
  ClearAuthParams = 'auth.ClearAuthParams',
  FetchFinish = 'auth.FetchFinish',
  FetchUser = 'auth.FetchUser',
  FetchLogout = 'auth.FetchLogout',
  FetchChangeNickname = 'auth.FetchChangeNickname',
  FetchRefreshToken = 'auth.FetchRefreshToken',
  FetchLastLoginAuth = 'auth.FetchLastLoginAuth',
  FetchTermsList = 'auth.FetchTermsList',
  FetchParentTermsList = 'auth.FetchParentTermsList',
  FetchAcceptTerms = 'auth.FetchAcceptTerms',
  FetchKakaoOAuthLogin = 'auth.FetchKakaoOAuthLogin',
  FetchDeleteUnverifiedUserData = 'auth.FetchDeleteUnverifiedUserData',
  FetchDeleteSnsUserData = 'auth.FetchDeleteSnsUserData',
  FetchUserCherryPicking = 'auth.FetchUserCherryPicking',
}

export const actions = {
  ...createBasicActions<IStateAuth>({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
    removeValuesActionType: ActionType.RemoveValues,
  }),
  clearAuthParams: () => createAction(ActionType.ClearAuthParams),
  fetchFinish: (needReload?: boolean) =>
    // TODO: createActionFetch의 params가 있을때는 payload가 필수 값이다. createActionFetch 매개변수/리턴 타입을 수정하자.
    createActionFetch(ActionType.FetchFinish, {
      payload: {needReload},
    }),
  fetchUser: (payload: {needDetail?: boolean}) =>
    createActionFetch(ActionType.FetchUser, {payload}),
  fetchLogout: () => createActionFetch(ActionType.FetchLogout),
  fetchChangeNickname: (nickname: string) =>
    createActionFetch(ActionType.FetchChangeNickname, {
      payload: {nickname},
    }),
  fetchRefreshToken: () => createActionFetch(ActionType.FetchRefreshToken),
  fetchLastLoginAuth: () => createActionFetch(ActionType.FetchLastLoginAuth),
  fetchTermsList: (sessionId?: string) =>
    createActionFetch(ActionType.FetchTermsList, {
      payload: {sessionId, isParent: false},
    }),
  fetchParentTermsList: (sessionId?: string) =>
    createActionFetch(ActionType.FetchParentTermsList, {
      payload: {sessionId, isParent: true},
    }),
  fetchAcceptTerms: (payload: {
    accepted: string;
    birthDate?: string;
    version: string;
    isParent: boolean;
    verificationSessionId?: string;
  }) => createActionFetch(ActionType.FetchAcceptTerms, {payload}),
  fetchKakaoOAuthLogin: (payload: {code: string; userAgent: IUserAgent}) =>
    createActionFetch(ActionType.FetchKakaoOAuthLogin, {payload}),
  fetchDeleteUnverifiedUserData: (verificationSessionId: string) =>
    createActionFetch(ActionType.FetchDeleteUnverifiedUserData, {
      payload: {verificationSessionId},
    }),
  fetchDeleteSnsUserData: (sessionId: string) =>
    createActionFetch(ActionType.FetchDeleteSnsUserData, {
      payload: {sessionId},
    }),
  fetchUserCherryPicking: () =>
    createActionFetch(ActionType.FetchUserCherryPicking),
};
